import Loader from "../Loader"

const LottiePlayer = () => {
    return (
        <div
            className='lottie_wrapper'
            style={{
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
                backgroundColor: 'var(--overlay)'
            }}
        >
            <div
                className='inner'
                style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <Loader />
            </div>
        </div>
    );
};

export default LottiePlayer;